import * as React from 'react'
import { injectIntl, InjectedIntlProps } from 'react-intl'
import MediaQuery from 'react-responsive'

import SearchIcon from '@uniiverse/library/assets/icons/new-search.svg'

import { BREAK_MD } from 'src/lib/media-queries'
import { useSupportsWebp } from 'src/hooks/useSupportsWebp'

import { TextInput } from '../text-input/index'
import { SearchInputs } from '../SearchInputs/SearchInputs'

import searchLocale from '../search/locale'
import searchInputsLocale from '../SearchInputs/locale'
import locale from './locale'

const style = require('./Hero.css')

// eslint-disable-next-line max-len
const PHOTO_URL: string = '/events/standon-calling-2019-weekend-tickets-25th-28th-july-tickets-colliers-end-CN73XW?ref=hero-standon-calling'
const PHOTO_COPYRIGHT: string = 'Standon Calling · United Kingdom'

interface Props {
  openSearch: (props: { sectionId?: string }) => void;
  lat: number;
  lon: number;
  locationQuery: string;
  history: History;
}

const containerClass = (supportsWebp: boolean): string => {
  let backgroundClass = ''
  if (supportsWebp !== null) {
    backgroundClass = supportsWebp ? style.backgroundWebp : style.backgroundJpeg
  }
  return `${style.container} ${backgroundClass}`
}

const HeroComponent: React.FunctionComponent<Props & InjectedIntlProps> = ({
  intl: { formatMessage },
  openSearch,
  lat,
  lon,
  locationQuery,
  history,
}) => (
  <div className={containerClass(useSupportsWebp())}>
    <div className={style.content}>
      <h1 className={style.slogan}>{formatMessage(locale.slogan)}</h1>
      <div className={style.searchContainer}>
        <MediaQuery minWidth={BREAK_MD}>
          <SearchInputs
            searchText={formatMessage(searchLocale.action)}
            searchQuery=""
            locationQuery={locationQuery}
            lat={lat}
            lon={lon}
            className={style.searchInputs}
            queryClassName={style.querySearchInputs}
            buttonClassName={style.searchButton}
            page="homepage"
            history={history}
            withSearchIcon
          />
        </MediaQuery>
        <MediaQuery maxWidth={BREAK_MD - 1}>
          <TextInput
            icon={<SearchIcon />}
            inputProps={{
              onClick: openSearch,
              defaultValue: '',
              placeholder: formatMessage(searchInputsLocale.searchPlaceholder),
              page: 'homepage',
            }}
          />
        </MediaQuery>
      </div>
      <div className={style.photoCredit}>
        <a href={PHOTO_URL} target="_blank" rel="noopener noreferrer">
          {PHOTO_COPYRIGHT}
        </a>
      </div>
    </div>
  </div>
)

export const Hero = injectIntl(HeroComponent)
